import Entity from "./entity";

/**
 * Represents a locationCode or even a position that can place orders.
 *
 * Object representation for a `LocationCode` document from the database.
 */
class LocationCode extends Entity {
  constructor({ id, location, restaurant, type } = {}) {
    super({ id: id });
    // location id
    this.location = location;
    // restaurant id
    this.restaurant = restaurant;
    this.type = type;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    return { ...this };
  }

  /**
   * @param {*} snapData `LocationCode` document data as a plain JS object
   * snapshot represented by this `LocationCode`.
   *
   * @returns {LocationCode} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    return new LocationCode(snapData);
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `LocationCode` belongs to.
   */
  get _collectionName() {
    return "locationCodes";
  }
}

export default LocationCode;
